import styled from 'styled-components';

const SubSection = styled.div`
  margin-bottom: 32px;
`;

const SubSectionTitle = styled.div`
  color: ${props => props.theme.secondaryColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 14px;
  line-height: 100%;
  text-transform: uppercase;
`;

const Text = styled.p`
  color: ${props => props.theme.bodyColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightRegular};
  font-size: 19px;
  line-height: 130%;
  margin-top: 8px;
  margin-bottom: 0px;

  &.multiline {
    white-space: pre-wrap;
  }
`;

export {
  SubSection,
  SubSectionTitle,
  Text,
};
